import {Spinner} from '@/components/Spinner/Spinner.jsx'
import styles from './AppButton.module.css'

export function AppButton(props) {
  const {
    variant = 'primary',
    loading = false,
    disabled,
    className = '',
    children,
    ...rest
  } = props

  return (
    <button
      type="button"
      disabled={disabled || loading}
      {...rest}
      className={`${styles.button} ${styles[variant]} ${className}`.trim()}
    >
      {loading && <Spinner size={18}/>}
      {children}
    </button>
  )
}
